import {totalNotificationsAtom} from 'atoms/notifications';
import {t} from 'i18next';
import {useAtomValue} from 'jotai';
import {useEffect} from 'react';

/**
 * Sets the document title while the component is mounted.
 *
 * Pass `restoreOnUnmount` for transient surfaces (e.g. the global search
 * overlay)
 */
export const useDocumentTitle = (title: string | null, restoreOnUnmount = false) => {
  const notificationCount: number = useAtomValue(totalNotificationsAtom);
  useEffect(() => {
    if (title === null) return;
    const previousTitle = document.title;
    document.title =
      notificationCount > 0
        ? `(${notificationCount}) ${title} - ${t('dropbox_os')}`
        : title + ' - ' + t('dropbox_os');
    if (!restoreOnUnmount) return;
    return () => {
      document.title = previousTitle;
    };
  }, [notificationCount, title, restoreOnUnmount]);
};
